import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Close from "@material-ui/icons/Close";
import MoreVert from "@material-ui/icons/MoreVert";
import { Grid, MenuItem } from "@material-ui/core";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";

import { openInWindow, withToggleModal } from "altus-ui-components";

import {
  GROUP_TYPES,
  EDIT_COMPANY_MODAL_ID,
} from "features/planner/planner.constants";

import {
  deleteViewGroup,
  initializeEditCompanyById,
  toggleViewGroupVisualState,
} from "features/planner/planner.actions";

import { toHeliReport } from "utils/route.util";
import groupService from "services/group.service";
import DropdownMenu from "app/components/DropdownMenu";
import ViewGroupIconButton from "features/planner/components/ViewGroup/ViewGroupIconButton";

class GroupHeaderMenu extends PureComponent {
  deleteViewGroup = () => {
    const { viewGroupId, dispatchDeleteViewGroup } = this.props;

    dispatchDeleteViewGroup(viewGroupId);
  };

  toggleViewGroupVisualState = () => {
    const {
      viewId,
      viewGroupId,
      dispatchToggleViewGroupVisualState,
    } = this.props;

    dispatchToggleViewGroupVisualState(viewId, viewGroupId);
  };

  initializeEditCompanyById = () => {
    const {
      group,
      dispatchToggleModal,
      dispatchInitializeEditCompanyById,
    } = this.props;

    dispatchInitializeEditCompanyById(group.get("companyId"), () =>
      dispatchToggleModal({ modalId: EDIT_COMPANY_MODAL_ID }),
    );
  };

  render() {
    const {
      group,
      groupId,
      expanded,
      groupType,
      displayMenu,
      displayDeleteBtn,
      displayExpandBtn,
      initializeEditLocationGroup,
    } = this.props;

    return (
      <>
        {displayMenu && groupType === GROUP_TYPES.LOCATION_GROUP && (
          <Grid item>
            <DropdownMenu
              Trigger={
                <ViewGroupIconButton>
                  <MoreVert fontSize="small" />
                </ViewGroupIconButton>
              }
            >
              <MenuItem onClick={initializeEditLocationGroup}>
                Edit Location
              </MenuItem>
              <MenuItem
                disabled={!group.get("companyId")}
                onClick={this.initializeEditCompanyById}
              >
                Edit Company
              </MenuItem>
              <MenuItem
                onClick={() =>
                  openInWindow({
                    to: toHeliReport(groupId),
                  })
                }
              >
                Helicopter Booking
              </MenuItem>
              <MenuItem
                onClick={() =>
                  groupService.redirectToSpecificationGapReport(groupId)
                }
              >
                Location Gap Report
              </MenuItem>
            </DropdownMenu>
          </Grid>
        )}
        {displayExpandBtn && (
          <Grid item>
            <ViewGroupIconButton
              title={expanded ? "Collapse" : "Expand"}
              onClick={this.toggleViewGroupVisualState}
            >
              {expanded && <ArrowDropUp fontSize="small" />}
              {!expanded && <ArrowDropDown fontSize="small" />}
            </ViewGroupIconButton>
          </Grid>
        )}
        {displayDeleteBtn && (
          <Grid item>
            <ViewGroupIconButton
              title="Remove from view"
              onClick={this.deleteViewGroup}
            >
              <Close fontSize="small" />
            </ViewGroupIconButton>
          </Grid>
        )}
      </>
    );
  }
}

GroupHeaderMenu.defaultProps = {
  displayMenu: true,
  displayDeleteBtn: true,
  displayExpandBtn: true,
};

export default compose(
  connect(null, {
    dispatchDeleteViewGroup: deleteViewGroup,
    dispatchInitializeEditCompanyById: initializeEditCompanyById,
    dispatchToggleViewGroupVisualState: toggleViewGroupVisualState,
  }),
  withToggleModal,
)(GroupHeaderMenu);
